"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
exports.CLASS_NAME = constants_1.BASE_CLASS_NAME + "__start-detail";
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return exports.CLASS_NAME;
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var StartDetail = (function (_super) {
    __extends(StartDetail, _super);
    function StartDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartDetail.prototype.getMetaComponent = function () {
        return Meta;
    };
    StartDetail.prototype.getMetaPropNames = function () {
        return [
            "className",
        ];
    };
    StartDetail.prototype.getChildComponent = function () {
        return "span";
    };
    StartDetail.Meta = Meta;
    return StartDetail;
}(base_1.DefaultComponentBase));
exports.default = StartDetail;
//# sourceMappingURL=StartDetail.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/list/lib/Item/StartDetail.js
// module id = ./node_modules/@react-mdc/list/lib/Item/StartDetail.js
// module chunks = 1